import axios from "axios";
import Cookies from "js-cookie";

import { createHttpClient } from "./createHttpClient.mjs";

const http = createHttpClient({
  axios,
  baseURL:
    process.env.VUE_APP_API_URL || "http://127.0.0.1:8000/api",
  getToken: () => Cookies.get("auth_token"),
});

export default http;

